import * as React from 'react';

interface IProps {
  fillColor?: string;
}

export default function SmilesIconPath(props: IProps) {
  return (
    <path
      fill={props.fillColor || '#000000'}
      fillRule="nonzero"
      // tslint:disable-next-line:max-line-length
      d="M6,0 C9.3137697,0 12,2.68626128 12,5.9999801 C12,9.3137387 9.3137697,12 6,12 C2.6862303,12 0,9.3137387 0,5.9999801 C0,2.68626128 2.6862303,0 6,0 Z M9.3362971,2.77294188 C8.8761388,2.29739473 8.1628357,2.98760994 8.622994,3.46315709 C9.2589462,4.1203986 9.6495285,5.0143969 9.6495285,6.0006978 C9.6495285,8.0162809 8.0155898,9.6501743 6,9.6501743 C3.9843703,9.6501743 2.3504715,8.0162809 2.3504715,6.0006978 C2.3504715,5.0143969 2.7410538,4.1203986 3.377006,3.46315709 C3.8371643,2.98760994 3.1238612,2.29739473 2.6637029,2.77294188 C1.8558242,3.60781082 1.3578677,4.7465802 1.3578677,6.0006978 C1.3578677,8.5644738 3.4361755,10.6427748 6,10.6427748 C8.5637846,10.6427748 10.6421323,8.5644738 10.6421323,6.0006978 C10.6421323,4.7465802 10.1441758,3.60781082 9.3362971,2.77294188 Z M5.7317837,1.84481355 C5.7317837,1.18306658 4.7391798,1.18306658 4.7391798,1.84481355 L4.7391798,5.8511 C4.7391798,6.5128071 5.7317837,6.5128071 5.7317837,5.8511 L5.7317837,1.84481355 Z M7.2608202,1.84481355 C7.2608202,1.18306658 6.2682163,1.18306658 6.2682163,1.84481355 L6.2682163,5.8511 C6.2682163,6.5128071 7.2608202,6.5128071 7.2608202,5.8511 L7.2608202,1.84481355 Z"
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/icons/SmilesIconPath.tsx